module.exports = __webpack_public_path__ + "static/img/3.2a53640.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/3.png
// module id = 4h0t
// module chunks = 0